export enum EContextMenuTypes {
	children = 'children',
	actions = 'actions',
	filter = 'filter',
	subFilter = 'sub-filter',
}

export type TContextMenuTypes = keyof typeof EContextMenuTypes;
